import { render, staticRenderFns } from "./createSales.vue?vue&type=template&id=42c9620f&scoped=true&"
import script from "./createSales.vue?vue&type=script&lang=js&"
export * from "./createSales.vue?vue&type=script&lang=js&"
import style0 from "./createSales.vue?vue&type=style&index=0&id=42c9620f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9620f",
  null
  
)

export default component.exports